<script setup lang="ts">
/**
 * GETリクエストでの、追加読み込み分表示機能付きAPIローディング表示コンテンツ。
 */
import { defineProps } from "vue";
import { ApiGetLoadAddStatusType, ApiGetLoadAddStatus } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadAddStatusType;
}
const props = defineProps<Props>();

/**
 * API成功時の表示をしていいかどうか。
 */
const isApiSuccessContentsDisplay = (): boolean => {
	// API処理成功状態であればOK
	if (props.status === ApiGetLoadAddStatus.success) {
		return true;
	}
	// 追加読み込みのAPIステータスは、API成功時の表示の後ろに追加表示されるので表示してOK
	if (props.status === ApiGetLoadAddStatus.addLoading || props.status === ApiGetLoadAddStatus.addError) {
		return true;
	}

	return false;
};
</script>

<template>
	<div class="revico-api-master">
		<!-- APIローディング状態に表示するコンテンツ -->
		<api-loading-display v-if="status === ApiGetLoadAddStatus.loading" />
		<!-- API成功時に表示するコンテンツ -->
		<!-- 追加読み込み時の表示は別途で行うため、追加読み込みステータスによってここの領域が表示されないことがないようにする -->
		<slot v-else-if="isApiSuccessContentsDisplay()" name="contents"></slot>
		<!-- API失敗時に表示するコンテンツ -->
		<api-error-display v-else-if="status === ApiGetLoadAddStatus.error" />

		<!-- 追加読み込み分のAPI処理表示 -->
		<!-- 追加読み込み分のAPIローディング状態に表示するコンテンツ -->
		<api-loading-display v-if="status === ApiGetLoadAddStatus.addLoading" />
		<!-- 追加読み込み分のAPI失敗時に表示するコンテンツ -->
		<api-error-display v-else-if="status === ApiGetLoadAddStatus.addError" />
	</div>
</template>
